import Font14 from '@assets/icons/font-14.svg'
import { Icon } from './Icon'

export const Font14Icon = Icon(Font14)
